"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledZillowLogo = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _fontColorMixin = require("../../mixins/fontColorMixin");
var StyledZillowLogo = /*#__PURE__*/_styledComponents.default.svg.withConfig({
  displayName: "StyledZillowLogo",
  componentId: "c11n-8-107-0__sc-yc584g-0"
})(["", ""], _fontColorMixin.fontColorMixin);
exports.StyledZillowLogo = StyledZillowLogo;